import React from 'react';
import './button.scss'

interface IButton {
  text?: string;
  type?: 'successTransparent' | 'primary' | 'primaryTransparent' | 'gradient' | 'grayTransparent' | 'deskbutton' | 'boothsbtn' | 'gradient1' | 'gradient2' | 'booths2btn' ;
  className?: string;
  style?: Object;
  onClick?: any;
}

const Button = ({ text = '', type = 'successTransparent', className = '', style= {}, onClick }: IButton) => {
  return (
    <button
      className={`app-btn app-btn-${type} ${className}`}
      style={style}
      onClick={onClick}
    >
      {text}
    </button>
  );
}

export default Button;